<template>
    <div>
        <div class="fade_payment" v-if="isLoadingPdf">
            <div class="w_full t_center">
                <i class="fa fa-file-pdf-o text-muted fa-3x"></i>
                <p class="text-muted m-t-20 m-b-30 t_uppercase">{{ $t('creating_pdf') }}</p>

                <!-- Balls Animated -->
                <div class="ball_payment space--huge">
                    <div class="preloader preloader__track preloader--bounce space--normal">
                        <div class="preloader__ball">
                            <div class="ball"></div>
                        </div>
                        <div class="preloader__ball">
                            <div class="ball"></div>
                        </div>
                        <div class="preloader__ball">
                            <div class="ball"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <iframe :src="src" frameborder="0" style="width: 100vw; height: 100vh;"></iframe>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { generatePdf } from 'services/my-quotation'

    export default {
        name: 'PDF',
        data () {
            return {
                isLoadingPdf: false,
                src: null
            }
        },
        created () {
            this.isLoadingPdf = true

            generatePdf(this.$route.params.code)
                .then(response => {
                    this.src = 'data:application/pdf;base64,' + response.data
                })
                .catch(() => Notify.error(trans('_notifications.error')))
                .then(() => { this.isLoadingPdf = false })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Pdf.vue